import { USER_TEMPLATE_FULL_PATH } from 'constants/paths';
import { SURVEY_FULL_PATH } from 'constants/paths';
import { GATHER_TEMPLATE_FULL_PATH } from 'constants/paths';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

function useSurveyType() {
  const location = useLocation();

  return useMemo(() => {
    const locations = location.pathname.replace(/^\/|\/$/g, '').split('/');

    const isSurvey = locations[1] === 'my-surveys';
    const isUserTemplate = locations[1] === 'my-templates';
    const isGatherTemplate = locations[1] === 'gather-templates';

    return {
      isSurvey,
      isUserTemplate,
      isGatherTemplate,
      surveyFullPath: isGatherTemplate
        ? GATHER_TEMPLATE_FULL_PATH
        : isUserTemplate
        ? USER_TEMPLATE_FULL_PATH
        : SURVEY_FULL_PATH,
      listLabel: isGatherTemplate ? 'Gather Templates' : isUserTemplate ? 'My Templates' : 'My Area'
    };
  }, [location]);
}

export default useSurveyType;
